module.exports = __webpack_public_path__ + "img/step1.f31d7d2f.svg";